module.exports = __webpack_public_path__ + "static/img/qqgroup.9a00fe26.png";